import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TeachHeader from "../Teacher/TeachHeader";
import axios, { decryptData } from "../Axiosinstance";
import {
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Table,
    Button, Typography,
    Paper,
    TextField, InputAdornment
} from "@mui/material";
import { ToastContainer } from "react-toastify";
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from "xlsx";
import Loader from '../Loader'
import { buttonBackgroundColor } from "../common";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';


const Container = ({ count }) => {
    const { batchId: encodedBatchId } = useParams();
    const batchId = decryptData(decodeURIComponent(encodedBatchId));
    const { intakeId } = useParams();

    const intakeId1 = decryptData(decodeURIComponent(intakeId));

    const theme = useTheme();
    const isLaptop = useMediaQuery('(min-width:600px) and (max-width:1400px)'); console.log('isLaptop', isLaptop)
    // console.log('isLaptop',isLaptop)
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [batchDetails, setBatchDetails] = useState(null);

    useEffect(() => {
        if (!batchId) return;

        const fetchBatchDetails = async () => {
            try {
                const response = await axios.get(`batch/${batchId}`);
                setBatchDetails(response.data);
            } catch (error) {
                console.error("Error fetching batch details:", error);
            }
        };

        fetchBatchDetails();
    }, [batchId]);

    if (!batchDetails) return <Loader />;





    return (
        <div style={{ marginTop: isMobile ? '70px' : isLaptop ? '50px' : '-50px', }}>

            <div style={{ maxWidth: "83%", minWidth: "80%", margin: "auto" }}>
                {/* Section Heading */}
                <Typography style={{ fontWeight: 'bolder', marginTop: "-1rem" }} variant="h4" textAlign="center" gutterBottom>
                    Batch Overview
                </Typography>

                {/* Batch Details Container */}
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        justifyContent: "space-between",
                        marginBottom: "30px"
                    }}
                >
                    {/* Left Column */}
                    <div
                        className="container-content shadow-sm rounded bg-light"
                        style={{
                            flex: "1 1 300px",
                            padding: "20px",
                            border: "1px solid #dee2e6"
                        }}
                    >
                        <p className="mb-2"><strong>Course:</strong> {batchDetails.course}</p>
                        <p className="mb-2"><strong>Course Date:</strong> {batchDetails.startDate}</p>
                        <p className="mb-0">
                            <strong>Trainers:</strong>{" "}
                            {Array.isArray(batchDetails.trainers) && batchDetails.trainers.length > 0
                                ? batchDetails.trainers.map(name => name.replace(/\(\d+\)/g, "").trim()).join(", ")
                                : "NA"}
                        </p>

                    </div>

                    {/* Right Column */}
                    <div
                        className="container-content shadow-sm rounded bg-light"
                        style={{
                            flex: "1 1 300px",
                            padding: "20px",
                            border: "1px solid #dee2e6"
                        }}
                    >
                        <p className="mb-2"><strong>Batch:</strong> {intakeId1}</p>
                        <p className="mb-2"><strong>Student Enrolled:</strong> {count}</p>
                        <p className="mb-0">
                            <strong>Assessors:</strong>{" "}
                            {Array.isArray(batchDetails.assessors) && batchDetails.assessors.length > 0
                                ? batchDetails.assessors
                                    .map(name => name.replace(/\(\d+\)/g, "").trim())
                                    .join(", ")
                                : "NA"}

                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const App = () => {
    const { intakeId } = useParams();
    const [search, setSearch] = useState("");
    const [students, setStudents] = useState([]);
    const intakeId1 = decryptData(decodeURIComponent(intakeId));

    useEffect(() => {
        if (intakeId1) fetchDataFromAPI();
    }, [intakeId1]);


    const fetchDataFromAPI = async () => {
        try {
            const response = await axios.get(`/registrationadvances/registration/active?intakeId=${intakeId1}`);
            setStudents(response.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const filteredStudents = students.filter((student) =>
        (student.name || "").toLowerCase().includes(search.toLowerCase())
    );

    const handleDownloadExcel = () => {
        if (!filteredStudents || filteredStudents.length === 0) {
            alert("No data to download.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(
            filteredStudents.map((student, index) => ({
                ID: index + 1,
                "Student Name": student.sName || student.name || "N/A",
                Email: student.sEmail || student.email || "N/A",
                "Registered On": student.enrolledDate
                    ? new Date(student.enrolledDate).toLocaleDateString("en-GB")
                    : "N/A",
                Status: student.status || "Pending",
            }))
        );

        // Set column widths for Excel
        ws["!cols"] = [
            { wch: 10 }, // ID
            { wch: 30 }, // Student Name
            { wch: 40 }, // Email
            { wch: 20 }, // Registered On
            { wch: 15 }, // Status
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Students");
        XLSX.writeFile(wb, "students.xlsx");
    };


    return (
        <div className="container-responsive">
            <TeachHeader />
            <Container count={students.length} />

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between", // aligns children left and right
                    alignItems: "center",
                    flexWrap: "wrap",
                    width: "80%", // take full width of parent
                    maxWidth: "1400px",
                    margin: "20px auto",
                    gap: "10px",
                }}
            >
                {/* Search Field on the Left */}
                <TextField
                    label="Search Name"
                    variant="outlined"
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        flex: "1 1 300px", // allows it to shrink and grow
                        minWidth: "250px",
                        maxWidth: "400px",
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                {/* Download Button on the Right */}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadExcel}
                    style={{
                        whiteSpace: "nowrap",
                        padding: "8px 20px",
                        backgroundColor: buttonBackgroundColor,
                        color: "white",
                        flexShrink: 0,
                    }}
                >
                    Download Excel
                </Button>
            </div>


            <TableContainer
                component={Paper}
                style={{
                    overflowX: "auto",
                    margin: "20px auto",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    maxWidth: "85%",

                }}
            >
                <Table
                    aria-label="student table"
                    style={{
                        tableLayout: "auto",
                        minWidth: "100%",
                    }}
                >
                    <TableHead>
                        <TableRow >
                            <TableCell sx={{ fontWeight: "bold" }}>S.No</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Student Name</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Registered on</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredStudents.length > 0 ? (
                            filteredStudents.map((student, index) => (
                                <TableRow
                                    key={student.id || index}
                                >
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{student.name || "N/A"}</TableCell>
                                    <TableCell>{student.email || "N/A"}</TableCell>
                                    <TableCell>
                                        {student.enrolledDate
                                            ? new Date(student.enrolledDate).toLocaleDateString("en-GB")
                                            : "N/A"}
                                    </TableCell>
                                    <TableCell>
                                        <span
                                            style={{
                                                padding: "4px 10px",
                                                backgroundColor:
                                                    student.status === "active"
                                                        ? "#008000" // Green for Active
                                                        : student.status === "Pending" || student.status === "Alumni"
                                                            ? "#dc3545" // Red for Pending or Alumni
                                                            : "#f8d7da", // Default red if status is not recognized
                                                color: "white",
                                                borderRadius: "6px",
                                                fontSize: "0.85rem",
                                                fontWeight: "500",
                                            }}
                                        >
                                            {student.status}
                                        </span>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No students found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>



        </div>
    );
};

export default App;
